import { render, staticRenderFns } from "./userJudai.vue?vue&type=template&id=12798d10&scoped=true&"
import script from "./userJudai.vue?vue&type=script&lang=js&"
export * from "./userJudai.vue?vue&type=script&lang=js&"
import style0 from "./userJudai.vue?vue&type=style&index=0&id=12798d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12798d10",
  null
  
)

export default component.exports